/* Meniul principal pe desktop: un singur rand, elementele care nu incap trec in "Mai multe",
   dropdown-uri la hover / click / tastatura. */
(function () {
  'use strict';

  function init(nav) {
    if (!nav || nav.__megaInit) { return; }
    nav.__megaInit = true;
    var list = nav.querySelector('.mega-nav__list'),
        more = nav.querySelector('.mega-nav__more'),
        moreList = more ? more.querySelector('.mega-nav__sub--more') : null,
        items = Array.prototype.slice.call(list.querySelectorAll(':scope > .mega-nav__item:not(.mega-nav__more)')),
        widths = [],
        openTimer = null, closeTimer = null;

    function isDesktop() { return window.innerWidth > 960; }

    function measure() {
      // latimile naturale ale elementelor, masurate cu toate vizibile
      items.forEach(function (it) { it.hidden = false; it.classList.remove('is-overflow'); });
      if (more) { more.hidden = true; }
      widths = items.map(function (it) { return it.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap || 0); });
    }

    function layout() {
      if (!more || !moreList) { return; }
      if (!isDesktop()) { items.forEach(function (it) { it.hidden = false; }); more.hidden = true; restoreAll(); return; }
      measure();
      var available = list.getBoundingClientRect().width, used = 0, moreWidth = 0;
      more.hidden = false; moreWidth = more.getBoundingClientRect().width + 16; more.hidden = true;
      var overflow = [];
      items.forEach(function (it, i) {
        used += widths[i];
        if (overflow.length || used > available - (i < items.length - 1 ? moreWidth : 0)) { overflow.push(it); }
      });
      if (overflow.length === items.length && items.length) { overflow.shift(); }
      restoreAll();
      if (overflow.length) {
        more.hidden = false;
        overflow.forEach(function (it) {
          it.hidden = true;
          var li = document.createElement('li');
          li.className = 'mega-nav__more-item' + (it.classList.contains('has-children') ? ' has-children' : '');
          var a = it.querySelector(':scope > .mega-nav__link');
          li.innerHTML = '<a href="' + a.getAttribute('href') + '">' + a.innerHTML + '</a>';
          var sub = it.querySelector(':scope > .mega-nav__panel > .mega-nav__sub');
          if (sub) { var clone = sub.cloneNode(true); clone.className = 'mega-nav__more-sub'; li.appendChild(clone); }
          moreList.appendChild(li);
        });
      }
    }
    function restoreAll() { if (moreList) { moreList.innerHTML = ''; } }

    function closeAll(except) {
      nav.querySelectorAll('.mega-nav__item.is-open').forEach(function (it) {
        if (it !== except) { it.classList.remove('is-open'); var b = it.querySelector(':scope > [aria-expanded]'); if (b) { b.setAttribute('aria-expanded', 'false'); } }
      });
    }
    function open(it) {
      closeAll(it);
      it.classList.add('is-open');
      var b = it.querySelector(':scope > [aria-expanded]'); if (b) { b.setAttribute('aria-expanded', 'true'); }
      // panoul nu iese din ecran
      var panel = it.querySelector(':scope > .mega-nav__panel');
      if (panel) {
        panel.style.left = ''; panel.style.right = ''; panel.style.transform = '';
        var r = panel.getBoundingClientRect(), vw = document.documentElement.clientWidth;
        if (r.right > vw - 12) { panel.style.left = 'auto'; panel.style.right = '0'; panel.style.transform = 'none'; }
        if (r.left < 12) { panel.style.left = '0'; panel.style.transform = 'none'; }
      }
    }

    /* Hover: mouseenter/mouseleave nu fac bubbling, le prindem in faza de capture. Reactionam DOAR cand
       evenimentul este chiar pe item (li), altfel parasirea unui link din panou declansa inchiderea
       desi cursorul era inca in dropdown. */
    function hoverItem(e) {
      var t = e.target;
      if (!t || t.nodeType !== 1 || !t.matches) { return null; }
      return t.matches('.mega-nav__item.has-children, .mega-nav__more') ? t : null;
    }
    nav.addEventListener('mouseenter', function (e) {
      if (!isDesktop()) { return; }
      var it = hoverItem(e);
      if (!it) { return; }
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(it); }, 60);
    }, true);
    nav.addEventListener('mouseleave', function (e) {
      if (!isDesktop()) { return; }
      var it = hoverItem(e);
      if (!it) { return; }
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (it.matches(':hover')) { return; }
        it.classList.remove('is-open'); var b = it.querySelector(':scope > [aria-expanded]'); if (b) { b.setAttribute('aria-expanded', 'false'); }
      }, 220);
    }, true);
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.mega-nav__toggle, .mega-nav__more-btn');
      if (!btn) { return; }
      e.preventDefault();
      var it = btn.closest('.mega-nav__item');
      if (it.classList.contains('is-open')) { closeAll(); } else { open(it); }
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); var b = nav.querySelector('.mega-nav__item.is-open [aria-expanded]'); if (b) { b.focus(); } }
    });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) { closeAll(); } });
    nav.addEventListener('focusout', function (e) { if (!nav.contains(e.relatedTarget)) { closeAll(); } });

    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 120); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); }
    layout();
  }

  function boot() { document.querySelectorAll('[data-mega-nav]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
